export function isUploadOpen(themeData) {
  const s = String(themeData?.upload_status ?? "open").trim().toLowerCase();
  return s !== "closed" && s !== "0" && s !== "false";
}

export function isVotingOpen(themeData) {
  const s = String(themeData?.voting_status ?? "open").trim().toLowerCase();
  return s !== "closed" && s !== "0" && s !== "false";
}

export function getUploadCount(themeData) {
  const n = Number.parseInt(String(themeData?.upload_count ?? "1"), 10);
  if (!Number.isFinite(n) || n < 1) return 1;
  return Math.min(n, 100);
}
